import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';

const EnergyStatsResume = ({ production, consumption }) => {
  const maxEnergy = 30000;
  const productionPct = Math.min((production / maxEnergy) * 100, 100);
  const consumptionPct = Math.min((consumption / maxEnergy) * 100, 100);
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { rootMargin: '-100px 0px 0px 0px' }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`energy-stats-resume-wrapper ${visible ? 'visible' : ''}`}
      style={{ width: '95%', margin: '0 auto' }}
    >
      <Row className="gx-2 mb-2">
        {[{
          title: 'PRODUCTION JOURNALIER MAXIMUM',
          value: production,
          color: 'success',
          note: 'Capacité de production de votre pack solaire'
        }, {
          title: 'VOTRE CONSOMMATION (Wh/j)',
          value: consumption,
          color: 'danger',
          note: 'Estimation basée sur vos équipements sélectionnés',
          alert: consumption > production
        }].map((stat, idx) => (
          <Col md={6} key={idx}>
            <div className="energy-card p-2 shadow-sm rounded">
              <h6 className="mb-1">{stat.title}</h6>
              <div className="d-flex justify-content-between align-items-center mb-1 small">
                <span>0 Wh</span>
                <span className={`fw-bold text-${stat.color}`}>{stat.value.toLocaleString()} Wh</span>
                <span>{maxEnergy.toLocaleString()} Wh</span>
              </div>
              <div className="progress" style={{ height: '18px' }}>
                <div
                  className={`progress-bar bg-${stat.color}`}
                  role="progressbar"
                  style={{ width: `${stat.color === 'success' ? productionPct : consumptionPct}%` }}
                  aria-valuenow={stat.value}
                  aria-valuemin="0"
                  aria-valuemax={maxEnergy}
                >
                  <span className="position-absolute" style={{ right: '8px', color: '#000', fontSize: '0.8rem' }}>
                    {stat.color === 'success' ? productionPct.toFixed(0) : consumptionPct.toFixed(0)}%
                  </span>
                </div>
              </div>
              <div className="mt-1 small text-muted">{stat.note}</div>
              {stat.alert && (
                <Alert variant="warning" className="mt-1 mb-0 py-1 small">
                  <strong>Attention!</strong> Consommation ({consumption.toLocaleString()} Wh) &gt; production ({production.toLocaleString()} Wh)
                </Alert>
              )}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default EnergyStatsResume;
